export enum ContactRoutePathsEnum {
  CONTACT = 'contact',
}
